import { useEffect } from 'react';

import { useIonAlert } from '@ionic/react';

import { useStorage } from 'components/Storage';

export const useUpdateApplication = () => {
  const [presentAlert] = useIonAlert();
  const storage = useStorage();

  useEffect(() => {
    const listener = async (message: any) => {
      if (message?.data === 'ReloadServiceWorker') {
        await presentAlert({
          header: 'New app version available',
          message: 'Please update the app',
          buttons: [
            {
              text: 'Update',
              handler: async () => {
                await storage?.clear();
                window.location.reload();
              },
            },
          ],
        });
      }
    };
    window.addEventListener('message', listener);
  }, []);
};
